import { routePath } from "../../shared/routes/index.js";

export const INITIAL_SIGN_IN = Object.freeze({
  step: "email",
  email: "",
  remembered: false,
  methods: [],
  method: null,
  expired: false,
  user: null,
});

export const nextFromResponse = (body) =>
  body?.next === "second_factor"
    ? { step: "second_factor", methods: body.methods ?? [] }
    : body?.next === "enrol"
    ? { step: "enrol" }
    : { step: "done", user: body?.data ?? null };

const firstMethod = (methods) =>
  methods.find((method) => method !== "recovery") ?? methods[0] ?? null;

const answered = (state, { body }) => {
  const next = nextFromResponse(body);

  return {
    ...state,
    ...next,
    method: next.methods ? firstMethod(next.methods) : state.method,
    expired: false,
  };
};

const changeAccount = () => INITIAL_SIGN_IN;

const TRANSITIONS = Object.freeze({
  email: {
    remembered: (state, { email }) => ({
      ...state,
      step: "credentials",
      email,
      remembered: true,
    }),
    email_entered: (state, { email }) => ({
      ...state,
      step: "credentials",
      email: email.trim(),
    }),
  },
  credentials: {
    change_account: changeAccount,
    answered,
  },
  second_factor: {
    change_account: changeAccount,
    answered,
    method_chosen: (state, { method }) =>
      state.methods.includes(method) ? { ...state, method } : state,
    expired: (state) => ({
      ...state,
      step: "credentials",
      methods: [],
      method: null,
      expired: true,
    }),
  },
});

export const signInStep = (state, event) =>
  TRANSITIONS[state.step]?.[event.type]?.(state, event) ?? state;

export const startSecondFactor = (methods) =>
  answered(INITIAL_SIGN_IN, { body: { next: "second_factor", methods } });

const searchFor = (destination) =>
  destination ? `?${new URLSearchParams({ r: destination })}` : "";

export const handOffFor = ({ body, destination }) =>
  body?.next === "second_factor"
    ? {
        pathname: routePath("auth.login"),
        search: searchFor(destination),
        state: { pending: { methods: body.methods ?? [] } },
      }
    : body?.next === "enrol"
    ? {
        pathname: routePath("auth.secure-account"),
        search: searchFor(destination),
      }
    : null;
